module.exports = __webpack_public_path__ + "img/sm_logo.5d95ada5.png";